export const Colors = {
    white: '#FFF',
    black: '#000',
    text: '#000426',
    border: '#BEBEBE',
    red: '#FC0000',

    green: {
        100: '#EBF0EB',
        200: '#C9E5D1',
        300: '#93CBA4',
    },
}
